import { defineMessages } from 'react-intl';

export const ERROR_MANAGER_MESSAGES = defineMessages({
    somethingWentWrong: {
        id: 'Something went wrong. Please try again.',
        defaultMessage: 'Something went wrong. Please try again.',
    },
    someSectionsMayNotDisplayCorrectly: {
        id: 'Some sections may not display correctly. Please try again.',
        defaultMessage: 'Some sections may not display correctly. Please try again.',
    },
    someSessionInformationMayNotDisplayCorrectly: {
        id: 'Some session information may not display correctly. Please try again.',
        defaultMessage: 'Some session information may not display correctly. Please try again.',
    },
    someAggregatedSalesInformationMayNotDisplayCorrectly: {
        id: 'Some aggregated sales information may not display correctly. Please try again.',
        defaultMessage: 'Some aggregated sales information may not display correctly. Please try again.',
    },
    eventDatesAreCurrentlyUnavailable: {
        id: 'Event dates are currently unavailable. Please try again.',
        defaultMessage: 'Event dates are currently unavailable. Please try again.',
    },
    troubleFetchingDataForDate: {
        id: "Something went wrong fetching details for the selected date",
        defaultMessage: "Something went wrong fetching details for the selected date",
    },
    troubleFetchingData: {
        id: "We're having trouble loading your data",
        defaultMessage: "We're having trouble loading your data",
    },
});